import {
  FIELD_ID,
  FORM_TYPE,
  INPUT_TYPE,
  NOT_PROVIDED_DATA,
  SELECT_EMPTY_VALUE,
} from './constants';

const isCheckboxFieldID = (fieldID: string): boolean =>
  [FIELD_ID.newsletter, FIELD_ID.tc].includes(fieldID);

const isCheckboxType = (type: string): boolean => type === INPUT_TYPE.checkbox;

const isInputsGroup = (type: string): boolean =>
  type === INPUT_TYPE.checkbox || type === INPUT_TYPE.radio;

const switchToEmptyValues = (formData: SignUpPageTypes.FormDataType) => {
  const newFormObject = {};
  Object.entries(formData).forEach(([key, value]) => {
    newFormObject[key] = value === SELECT_EMPTY_VALUE ? '' : value;
  });

  return newFormObject;
};

const prepareCdpData = (
  formWithEmptyValues: SignUpPageTypes.FormDataType,
  formType: SignUpPageTypes.FormType
) => ({
  TierCode: process.env.GATSBY_CDP_TIER_CODE,
  SourceCode: process.env.GATSBY_CDP_SOURCE_CODE,
  EnrollmentStatus: 'A',
  EnrollChannelCode: 'WEB',
  LanguageCode: 'GBR',
  FirstName: formWithEmptyValues.FirstName,
  LastName: formWithEmptyValues.LastName || NOT_PROVIDED_DATA,
  Addresses: [
    {
      CountryCode: 'GBR',
      PostalCode: formWithEmptyValues.PostalCode,
      DeliveryStatus: 'G',
    },
  ],
  Emails: [
    {
      EmailAddress: formWithEmptyValues.EmailAddress,
      DeliveryStatus: 'G',
    },
  ],
  ...(formType === FORM_TYPE.organization && formWithEmptyValues.BusinessPhoneNumber
    ? {
        Phones: [
          {
            PhoneNumber: formWithEmptyValues.BusinessPhoneNumber,
            DeliveryStatus: 'G',
          },
        ],
      }
    : {}),
  JsonExternalData: {
    Agreements: [
      {
        RevisionId: process.env.GATSBY_HEALTH_LDS_REVISION_ID,
        BusinessId: process.env.GATSBY_BUSINESS_ID,
        ConsentAcceptedInd: true,
        ConsentDesc: 'TC',
        MandatoryInd: false,
        AgreementDate: new Date().toISOString(),
        ActivityDate: new Date().toISOString(),
        Status: 'A',
      },
      {
        RevisionId: process.env.GATSBY_HEALTH_LDS_PP_REVISION_ID,
        BusinessId: process.env.GATSBY_PP_BUSINESS_ID,
        ConsentAcceptedInd: true,
        ConsentDesc: 'PP',
        MandatoryInd: false,
        AgreementDate: new Date().toISOString(),
        ActivityDate: new Date().toISOString(),
        Status: 'A',
      },
    ],
    ProfileSubscriptions: [
      {
        SubscriptionId: process.env.GATSBY_CDP_SUBSCRIPTION_ID,
        OptSource: 'WEB',
        ChannelCode: 'EM',
        OptStatus: true,
        ActivityDate: new Date().toISOString(),
        Status: 'A',
        JsonExternalData: {
          ContactPointValue: formWithEmptyValues.EmailAddress,
          EmailOptFlag: 'Y',
        },
      },
    ],
    UnmappedAttributes: {
      OtherPostalCode: formWithEmptyValues.OtherPostalCode || NOT_PROVIDED_DATA,
      ...(formType === FORM_TYPE.organization
        ? {
            OrganisationName: formWithEmptyValues.Organisation,
            JobRole: formWithEmptyValues.JobRole || NOT_PROVIDED_DATA,
            NumberOfEmployees: formWithEmptyValues.EmployeesNumber,
            Sector: formWithEmptyValues.Sector,
            Industry: formWithEmptyValues.Industry,
            OtherIndustry: formWithEmptyValues.OtherIndustry || NOT_PROVIDED_DATA,
          }
        : {
            Age: formWithEmptyValues.Age,
            Gender: formWithEmptyValues.Gender,
          }),
    },
  },
});

export { isCheckboxFieldID, isCheckboxType, isInputsGroup, prepareCdpData, switchToEmptyValues };
